module.exports = __webpack_public_path__ + "static/media/filter.a8ed45fc.svg";